declare namespace $ {

	type $mol_link__uri_bog_effects_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_effects_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__uri_bog_effects_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_effects_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_effects_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects extends $mol_page {
		subtitle( ): string
		article_label( ): string
		Article( ): $mol_link
		sources_label( ): string
		Sources( ): $mol_link
		Links( ): $mol_view
		Intro( ): $mol_view
		Demo01( ): $bog_effects_demo01
		Demo02( ): $bog_effects_demo02
		Demo03( ): $bog_effects_demo03
		Demo04( ): $bog_effects_demo04
		Demo05( ): $bog_effects_demo05
		Demo06( ): $bog_effects_demo06
		Demo07( ): $bog_effects_demo07
		Demo08( ): $bog_effects_demo08
		Demo09( ): $bog_effects_demo09
		Demo10( ): $bog_effects_demo10
		Demo11( ): $bog_effects_demo11
		Demo12( ): $bog_effects_demo12
		title( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_view__sub_bog_effects_card_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_card_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_card_3 = $mol_type_enforce<
		ReturnType< $bog_effects_card['body'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_card extends $mol_view {
		Title( ): $mol_view
		Descr( ): $mol_view
		body( ): readonly(any)[]
		Content( ): $mol_view
		title( ): string
		descr( ): string
		sub( ): readonly(any)[]
	}
	
	type $mol_string__hint_bog_effects_demo01_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_effects_demo01_2 = $mol_type_enforce<
		ReturnType< $bog_effects_demo01['first_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_effects_demo01_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_effects_demo01_4 = $mol_type_enforce<
		ReturnType< $bog_effects_demo01['last_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_bog_effects_demo01_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo01 extends $bog_effects_card {
		first_name( next?: string ): string
		First( ): $mol_string
		last_name( next?: string ): string
		Last( ): $mol_string
		full_name( ): string
		Full( ): $mol_view
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_switch__value_bog_effects_demo02_1 = $mol_type_enforce<
		ReturnType< $bog_effects_demo02['filter'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_effects_demo02_2 = $mol_type_enforce<
		({ 
			'all': string,
			'active': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_list__rows_bog_effects_demo02_3 = $mol_type_enforce<
		ReturnType< $bog_effects_demo02['todo_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_effects_demo02_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo02 extends $bog_effects_card {
		filter( next?: string ): string
		Filter( ): $mol_switch
		todo_rows( ): readonly(any)[]
		List( ): $mol_list
		row_title( id: any): string
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
		Row( id: any): $mol_view
	}
	
	type $mol_switch__value_bog_effects_demo03_1 = $mol_type_enforce<
		ReturnType< $bog_effects_demo03['user'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_effects_demo03_2 = $mol_type_enforce<
		({ 
			'anna': string,
			'boris': string,
			'vera': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_textarea__hint_bog_effects_demo03_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_effects_demo03_4 = $mol_type_enforce<
		ReturnType< $bog_effects_demo03['current_comment'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	export class $bog_effects_demo03 extends $bog_effects_card {
		user( next?: string ): string
		User( ): $mol_switch
		current_comment( next?: string ): string
		Comment( ): $mol_textarea
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_list__rows_bog_effects_demo04_1 = $mol_type_enforce<
		ReturnType< $bog_effects_demo04['item_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_effects_demo04_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_effects_demo04_3 = $mol_type_enforce<
		ReturnType< $bog_effects_demo04['select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_effects_demo04_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_effects_demo04_5 = $mol_type_enforce<
		ReturnType< $bog_effects_demo04['remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_effects_demo04_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_effects_demo04_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo04 extends $bog_effects_card {
		item_rows( ): readonly(any)[]
		List( ): $mol_list
		selection_label( ): string
		Selected( ): $mol_view
		select( id: any, next?: any ): any
		item_name( id: any): string
		Pick( id: any): $mol_button_minor
		remove( id: any, next?: any ): any
		del_label( ): string
		Del( id: any): $mol_button_minor
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
		Row( id: any): $mol_view
	}
	
	type $mol_view__sub_bog_effects_demo05_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__click_bog_effects_demo05_2 = $mol_type_enforce<
		ReturnType< $bog_effects_demo05['to_cart'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_effects_demo05_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_bog_effects_demo05_4 = $mol_type_enforce<
		ReturnType< $bog_effects_demo05['buy_now'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_effects_demo05_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_effects_demo05_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_demo05_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo05 extends $bog_effects_card {
		product_title( ): string
		Card( ): $mol_view
		to_cart( next?: any ): any
		cart_label( ): string
		ToCart( ): $mol_button_major
		buy_now( next?: any ): any
		buy_label( ): string
		BuyNow( ): $mol_button_major
		Buttons( ): $mol_view
		status( ): string
		Status( ): $mol_view
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_string__hint_bog_effects_demo06_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_effects_demo06_2 = $mol_type_enforce<
		ReturnType< $bog_effects_demo06['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_effects_demo06_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_effects_demo06_4 = $mol_type_enforce<
		ReturnType< $bog_effects_demo06['email'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_major__enabled_bog_effects_demo06_5 = $mol_type_enforce<
		ReturnType< $bog_effects_demo06['can_submit'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_bog_effects_demo06_6 = $mol_type_enforce<
		ReturnType< $bog_effects_demo06['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_effects_demo06_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_effects_demo06_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo06 extends $bog_effects_card {
		name( next?: string ): string
		Name( ): $mol_string
		email( next?: string ): string
		Email( ): $mol_string
		can_submit( ): boolean
		submit( next?: any ): any
		submit_title( ): string
		Submit( ): $mol_button_major
		result( ): string
		Result( ): $mol_view
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_button_major__enabled_bog_effects_demo07_1 = $mol_type_enforce<
		ReturnType< $bog_effects_demo07['playable'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_bog_effects_demo07_2 = $mol_type_enforce<
		ReturnType< $bog_effects_demo07['place_normal'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_effects_demo07_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__enabled_bog_effects_demo07_4 = $mol_type_enforce<
		ReturnType< $bog_effects_demo07['playable'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_bog_effects_demo07_5 = $mol_type_enforce<
		ReturnType< $bog_effects_demo07['place_gold'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_effects_demo07_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_effects_demo07_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_demo07_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_effects_demo07_9 = $mol_type_enforce<
		ReturnType< $bog_effects_demo07['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_effects_demo07_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_effects_demo07 extends $bog_effects_card {
		playable( ): boolean
		place_normal( next?: any ): any
		normal_label( ): string
		Normal( ): $mol_button_major
		place_gold( next?: any ): any
		gold_label( ): string
		Gold( ): $mol_button_major
		Buttons( ): $mol_view
		score( ): string
		Score( ): $mol_view
		reset( next?: any ): any
		reset_label( ): string
		Reset( ): $mol_button_minor
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_check_box__checked_bog_effects_demo08_1 = $mol_type_enforce<
		ReturnType< $bog_effects_demo08['light_on'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__label_bog_effects_demo08_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check_box['label'] >
	>
	type $mol_view__sub_bog_effects_demo08_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo08 extends $bog_effects_card {
		light_on( next?: boolean ): boolean
		toggle_label( ): string
		Toggle( ): $mol_check_box
		light_status( ): string
		Status( ): $mol_view
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_button_minor__click_bog_effects_demo09_1 = $mol_type_enforce<
		ReturnType< $bog_effects_demo09['reveal'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_effects_demo09_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_effects_demo09_3 = $mol_type_enforce<
		ReturnType< $bog_effects_demo09['panel_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_demo09_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo09 extends $bog_effects_card {
		reveal( next?: any ): any
		reveal_label( ): string
		Reveal( ): $mol_button_minor
		panel_content( ): readonly(any)[]
		Panel( ): $mol_view
		visits_label( ): string
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
		Visits( ): $mol_view
	}
	
	type $mol_view__sub_bog_effects_demo10_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_demo10_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo10 extends $bog_effects_card {
		clock( ): string
		Clock( ): $mol_view
		online_label( ): string
		Online( ): $mol_view
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_switch__value_bog_effects_demo11_1 = $mol_type_enforce<
		ReturnType< $bog_effects_demo11['room'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_effects_demo11_2 = $mol_type_enforce<
		({ 
			'general': string,
			'travel': string,
			'music': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_switch__value_bog_effects_demo11_3 = $mol_type_enforce<
		ReturnType< $bog_effects_demo11['theme'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_effects_demo11_4 = $mol_type_enforce<
		({ 
			'light': string,
			'dark': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_view__sub_bog_effects_demo11_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_demo11_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo11 extends $bog_effects_card {
		room( next?: string ): string
		Room( ): $mol_switch
		theme( next?: string ): string
		Theme( ): $mol_switch
		notice( ): string
		Notice( ): $mol_view
		reconnects_label( ): string
		Reconnects( ): $mol_view
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_string__hint_bog_effects_demo12_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_effects_demo12_2 = $mol_type_enforce<
		ReturnType< $bog_effects_demo12['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_list__rows_bog_effects_demo12_3 = $mol_type_enforce<
		ReturnType< $bog_effects_demo12['result_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_effects_demo12_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_effects_demo12_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_effects_demo12 extends $bog_effects_card {
		query( next?: string ): string
		Query( ): $mol_string
		result_rows( ): readonly(any)[]
		Results( ): $mol_list
		done_label( ): string
		Done( ): $mol_view
		row_title( id: any): string
		title( ): string
		descr( ): string
		body( ): readonly(any)[]
		Row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=effects.view.tree.d.ts.map